
























































































import { Component, Vue, Watch } from "@/shared/vuepack";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { FinicityIFrameLocation, HsabExpenseFormStep } from "@/shared/types";
import * as routeNames from "@/employee/route-names";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class HsabExpenseFormAddBankAccount extends Vue {
  hsabExpenseStore = useHsabExpenseStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  bankAccountStore = useBankAccountStore();

  mounted () {
    this.bankAccountStore.loadBankAccountState(); // should already be loaded
  }


  @Watch("bankAccountStore.linkedAccountsLoaded", {immediate: true})
  onBankAccountsLoaded (isLoaded) {
    if (isLoaded && !this.bankAccountStore.hasDirectDepositAccount) {
      this.bankAccountStore.addFinicityConnectScriptToHead(document);
    }
  }

  @Watch("bankAccountStore.hasDirectDeposit", {immediate: true})
  onHasDirectDepositChanged (hasDirectDeposit) {
    if (hasDirectDeposit && this.hsabExpenseFormStore.formStepToDisplay === HsabExpenseFormStep.addBankAccount) {
      this.hsabExpenseFormStore.formStepToDisplay = HsabExpenseFormStep.confirmation;
    }
  }

  get showSpinner () {
    return this.bankAccountStore.isAchVerifierUrlLoading
        || this.bankAccountStore.isAccountDelayInfoPanelLoaded;
  }

  onNoThanksClicked () {
    this.hsabExpenseFormStore.formStepToDisplay = HsabExpenseFormStep.confirmation;
  }

  get showTextAndButtons () {
    return !this.showSpinner && !this.showIFrame;
  }

  get showAddAccountButton () {
    return !this.bankAccountStore.hasDirectDeposit && !this.bankAccountStore.isMissingUses;
  }

  get showVisitExistingAccountsButton () {
    return !this.bankAccountStore.hasDirectDeposit && this.bankAccountStore.isMissingUses;
  }

  get showPleaseWait () {
    return this.bankAccountStore.isAccountDelayInfoPanelLoaded;
  }

  get showIFrame () {
    return this.bankAccountStore.isAchIFrameLoaded;
  }

  onAddBankAccountClicked () {
    this.bankAccountStore.retrieveAchVerifierUrl(window, FinicityIFrameLocation.expenseForm);
  }

  get expenseForm () {
    return this.hsabExpenseFormStore.expenseForm;
  }

  saveAndNavigateToAccounts () {
    this.hsabExpenseFormStore.isSaving = true;
    if (!this.expenseForm.isPayToPayee) {
      this.expenseForm.payeeName = "";
      this.expenseForm.payeeMemberNumber = "";
      this.expenseForm.payeeAddress1 = "";
      this.expenseForm.payeeAddress2 = "";
      this.expenseForm.payeeCity = "";
      this.expenseForm.payeeStateCode = "";
      this.expenseForm.payeeZipCode = "";
    }

    return this.hsabExpenseStore.saveExpense(this.expenseForm)
        .then(_ => {
          this.hsabExpenseFormStore.isSaving = false;
          this.$emit("close-action");
          this.$router.push({name: routeNames.LinkedAccountsSettings});
        })
        .catch(_ => {
          this.hsabExpenseFormStore.isSaving = false;
        });

  }
}
